import { Locale, Language } from './types';

const getMomentLocale = (lang: Language) => Locale[lang];

export default getMomentLocale;
